import React, { useState, useEffect, useRef } from 'react';
import LeaseApiService from '../../services/apiService';
import Select from 'react-select';
import { RiRefreshLine } from 'react-icons/ri';
import { IoAdd } from 'react-icons/io5';
import { GrDocumentUpdate } from 'react-icons/gr';
import { ClipLoader } from 'react-spinners';
import { getName } from '../../../Redux/selecters';
import { useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { useNavigate } from 'react-router-dom';
import DatePicker from 'react-datepicker';
import 'react-datepicker/dist/react-datepicker.css';
import { MdDelete } from 'react-icons/md';
import { FiEdit } from 'react-icons/fi';
import { FaSave, FaChevronLeft, FaEdit, FaTrash } from 'react-icons/fa';
import { useCurrency } from '../../../INVENTORY/Layouts/currencyContext';
import PaymentInvoices from './paymentList';
import Modal from 'react-bootstrap/Modal';

const getEmptyUnitForm = () => ({
  vatRecord: '',
  Property: [],
  Unit: [],
  noCommunity: '',
  rentPerAnum: '',
  unitClass: '',
  type: '',
  rentForPeriod: '',
  unitRefNo: '',
  rentAmount: '',
  bedRooms: '',
  FreeRent: '',
  discountPerc: '',
  totalArea: '',
  Landloard: '',
  taxCode: [],
  category: '',
  vat: '',
  discount: '',
  total: 0,
  parkingNo: '',
  munAcNo: '',
  Parking: '',
  taxRate: '',
  month: '',
  increment: '',
});

const getEmptyDataList = () => [getEmptyUnitForm()];

const getDefaultPeriodDates = () => {
  const today = new Date();
  const nextYear = new Date(today);
  nextYear.setFullYear(today.getFullYear() + 1);
  nextYear.setDate(nextYear.getDate() - 1);
  return {
    periodFrom: today.toISOString().split('T')[0],
    periodTo: nextYear.toISOString().split('T')[0],
  };
};

const getEmptyTransData = (periodFrom, periodTo, leaseTerm = '') => ({
  transectionDate: periodFrom,
  periodFrom,
  periodTo,
  leaseTerm,
  noInstallment: '',
  CustomerName: '',
  CustomerAccount: '',
  leaseAgent: '',
  JointCustomerName: '',
  JointCustomerAccount: '',
  Broker: '',
  remarks: '',
  remarks2: '',
  arabicRemarks: '',
});

const calculateDaysDifference = (from, to) => {
  const fromDate = new Date(from);
  const toDate = new Date(to);

  fromDate.setHours(0, 0, 0, 0);
  toDate.setHours(0, 0, 0, 0);

  return Math.floor((toDate - fromDate) / (1000 * 60 * 60 * 24)) + 1;
};

const AddLeaseAgrement = ({ show = true, onClose, onSaved }) => {
  const apiService = new LeaseApiService();
  const gridRef = useRef();
  const navigate = useNavigate();
  const { currencyPrecision } = useCurrency();
  const userName = useSelector(getName);
  const [unitData, setUntData] = useState();
  const [loading, setloader] = useState(false);
  const [periodTo, setPeriodTo] = useState('');
  const [activeTab, setActiveTab] = useState(0);
  const [unitList, setUnitList] = useState([]);
  const [unitRent, setUnitRent] = useState(true);
  const [leaseTerm, setLeaseTerm] = useState('');
  const [editIndex, setEditIndex] = useState(null);
  const [periodFrom, setPeriodFrom] = useState('');
  const [FilterTab, setFilterTab] = useState(true);
  const [rentCheck, setRentCheck] = useState(false);
  const [taxCodeList, setTaxCodeList] = useState([]);
  const [remarksList, setRemarksList] = useState([]);
  const [tentantTab, setTanantTab] = useState(false);
  const [showUpdate, setShowUpdate] = useState(false);
  const [propertylist, setPropertyList] = useState([]);
  const [customerList, setCUstomerList] = useState([]);
  const [leasingAgent, setLeasingAgent] = useState([]);
  const [tentantJoint, setTanantJoint] = useState(false);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const [additionalCharges, setAdditionalCharges] = useState([]);
  const [InvoiceList, setInvoiceList] = useState([]);
  const [financialYear, setFinancialYear] = useState(null);
  const [gridVisibility, setGridVisibility] = useState([true, false, false, false]);
  const [dataList, setDataList] = useState(getEmptyDataList);
  const totalVat = dataList.reduce((sum, row) => sum + (parseFloat(row?.vat) || 0), 0);
  const calculatedTotal = dataList.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0);
  const totalDiscount = dataList.reduce((sum, row) => sum + (parseFloat(row?.FreeRent) || 0), 0);
  const rentPerAnum = dataList.reduce((sum, row) => sum + (parseFloat(row?.rentPerAnum) || 0), 0);
  const totalRent = dataList.reduce((sum, row) => sum + (parseFloat(row?.rentForPeriod) || 0), 0);
  useEffect(() => {
    const financialYears = JSON.parse(localStorage.getItem('financialYear')) || [];
    const activeFinancialYear = financialYears?.find((fy) => fy.isActive);
    setFinancialYear(activeFinancialYear.id);
    getUserList();
  }, []);
  const getUserList = async () => {
    try {
      const params = new URLSearchParams();
      params.append('dropdownTypes', 'LASerPropertyName,LACustomerName,LALeasingAgent,LALeaseRemarks,VatPercentage');
      const customerRes = await apiService.getApiParamater('GET_PROPERT_DROP', `?${params?.toString()}`);
      setCUstomerList(customerRes?.data?.dropdowns?.LACustomerName);
      setPropertyList(customerRes?.data?.dropdowns?.LASerPropertyName);
      setLeasingAgent(customerRes?.data?.dropdowns?.LALeasingAgent);
      setRemarksList(customerRes?.data?.dropdowns?.LALeaseRemarks);
      setTaxCodeList(customerRes?.data?.dropdowns?.VatPercentage);
    } catch (error) {
      console.error('Error fetching data:', error?.customerRes?.data?.message);
    }
  };
  const [formData, setFormData] = useState(getEmptyUnitForm);
  const [transData, setTransData] = useState(() => getEmptyTransData('', '', ''));
  const handleChange = (e) => {
    const { name, value } = e.target;
    if (name === 'rentForPeriod') {
      let newvalue = parseFloat(value) || 0;
      let taxCode = parseFloat(formData?.taxRate) || 0;
      let discountPerc = parseFloat(formData?.discountPerc) || 0;

      // Calculate discount and tax
      let discountAmount = (newvalue * discountPerc) / 100;
      let taxAmount = (newvalue * taxCode) / 100;

      // Calculate total amount
      let totalAmount = newvalue - discountAmount + taxAmount;

      setFormData({
        ...formData,
        rentForPeriod: newvalue,
        total: totalAmount,
        FreeRent: discountAmount,
        vat: taxAmount,
        rentAmount: newvalue,
      });
    } else if (name === 'discountPerc') {
      let newvalue = parseFloat(value) || 0;
      let taxCode = parseFloat(formData?.taxRate) || 0;
      let amount = parseFloat(formData?.rentForPeriod) || 0;
      // Calculate discount and tax
      let discountAmount = (amount * newvalue) / 100;
      let taxAmount = (amount * taxCode) / 100;

      // Calculate total amount
      let totalAmount = amount - discountAmount + taxAmount;

      setFormData({
        ...formData,
        total: totalAmount,
        discountPerc: newvalue,
        FreeRent: discountAmount,
        rentAmount: amount - discountAmount,
        vat: taxAmount,
      });
    } else if (name === 'FreeRent') {
      let newvalue = parseFloat(value) || 0;
      let taxCode = parseFloat(formData?.taxRate) || 0;
      let amount = parseFloat(formData?.rentForPeriod) || 0;
      // Calculate discount and tax
      let taxAmount = (amount * taxCode) / 100;
      let discountAmountPerc = amount > 0 ? (newvalue / amount) * 100 : 0;

      // Calculate total amount
      let totalAmount = amount - newvalue + taxAmount;

      setFormData({
        ...formData,
        total: totalAmount,
        discountPerc: discountAmountPerc?.toFixed(currencyPrecision?.decimalNumbers),
        FreeRent: newvalue,
        vat: taxAmount,
        rentAmount: amount - newvalue,
      });
    } else {
      setFormData({ ...formData, [e.target.name]: e.target.value });
    }
  };
  const handleclearform = () => {
    setFormData(getEmptyUnitForm());
  };
  const handleResetAll = () => {
    const { periodFrom: defaultFrom, periodTo: defaultTo } = getDefaultPeriodDates();
    const defaultLeaseTerm = calculateDaysDifference(defaultFrom, defaultTo);

    setFormData(getEmptyUnitForm());
    setDataList(getEmptyDataList());
    setTransData(getEmptyTransData(defaultFrom, defaultTo, defaultLeaseTerm));
    setPeriodFrom(defaultFrom);
    setPeriodTo(defaultTo);
    setLeaseTerm(defaultLeaseTerm);
    setUntData(undefined);
    setUnitList([]);
    setEditIndex(null);
    setSelectedIndex(null);
    setShowUpdate(false);
    setTanantTab(false);
    setTanantJoint(false);
    setRentCheck(false);
    setUnitRent(true);
    setFilterTab(true);
    setAdditionalCharges([]);
    setInvoiceList([]);
    setActiveTab(0);
    setGridVisibility([true, false, false, false]);
  };
  const handleAdd = async () => {
    const requiredFields = [
      { key: 'Property.label', message: 'Please Select Property' },
      { key: 'Unit.label', message: 'Please Select Unit No' },
    ];
    if (!transData?.noInstallment) {
      toast.warning(`Please Enter No of Installment`);
      setloader(false);
      return;
    }
    for (const field of dataList) {
      if (field?.Unit?.label === formData?.Unit?.label) {
        toast.warning(`${formData?.Unit?.label} for this Property Already Selected please add another unit`);
        return;
      }
    }
    for (const field of requiredFields) {
      const keys = field.key.split('.');
      let value = formData;
      for (const key of keys) {
        value = value?.[key];
      }
      if (!value) {
        toast.warning(field.message);
        return;
      }
    }
    if (!dataList[0]?.Property?.label) {
      setDataList((prevEntries) => prevEntries.slice(1));
    }
    if (editIndex !== null) {
      const updatedEntries = [...dataList];
      updatedEntries[editIndex] = formData;
      setDataList(updatedEntries);
      setEditIndex(null);
      handlePaymentPlan(updatedEntries);
      handleclearform();
    } else {
      const updatedList = [...dataList, formData];

      const list = !updatedList[0]?.Property?.label ? updatedList.slice(1) : updatedList;
      setDataList(list);
      handlePaymentPlan(list);
      handleclearform();
    }
  };
  const handleEdit = (index) => {
    setFormData(dataList[index]);
    setEditIndex(index);
  };
  const handleUpdate = () => {
    const updatedList = [...dataList];
    updatedList[editIndex] = { ...formData };

    setDataList(updatedList);
    setSelectedIndex(null);
    setEditIndex(null);
    setShowUpdate(false);
    handleclearform();
    handlePaymentPlan(updatedList);
  };
  const handleDelete = (index) => {
    const updatedEntries = dataList.filter((_, i) => i !== index);
    setDataList(updatedEntries);
    if (editIndex === index) {
      setFormData(getEmptyUnitForm());
      setEditIndex(null);
    }
  };
  const handleTabClick = (tabIndex) => {
    setActiveTab(tabIndex);
    const newGridVisibility = gridVisibility.map((_, index) => index === tabIndex);
    setGridVisibility(newGridVisibility);
  };
  const handlePropertyChange = async (selectedOption) => {
    const params = new URLSearchParams();
    params.append('DropdownFor', 'LASerUnitNos');
    params.append('CascadValue', selectedOption?.value);
    const res = await apiService.getApiParamater('GET_UNITNO_DROP', `?${params?.toString()}`);
    setUnitList(res?.data?.items);
    setFormData({
      ...formData,
      Property: selectedOption,
    });
  };
  const handleTaxChange = async (selectedOption) => {
    let discountPerc = parseFloat(formData?.discountPerc) || 0;
    let discount = parseFloat(formData?.FreeRent) || 0;
    let amount = parseFloat(formData?.rentForPeriod);

    // Calculate total amount

    const taxParam = new URLSearchParams();
    taxParam.append('Action', 'GetTaxRecordIdByTaxName');
    taxParam.append('TaxDescription', selectedOption?.label);
    const taxrecord = await apiService.getApiParamater('GET_UNITNO_DATA', `?${taxParam?.toString()}`);
    let recordId = taxrecord?.data?.result?.data?.RecordId;
    let Rate = taxrecord?.data?.result?.data?.Rate;
    let taxAmount = (amount * Rate) / 100;
    let totalAmount = amount - discount + taxAmount;
    debugger;
    setFormData({
      ...formData,
      vatRecord: recordId,
      taxRate: Rate,
      total: totalAmount,
      taxCode: selectedOption,
      vat: taxAmount,
    });
  };
  const handleUnitChange = async (selectedOption) => {
    setFormData({
      ...formData,
      Unit: selectedOption,
    });
    const params = new URLSearchParams();
    params.append('Action', 'GetUnitDetailsByUnitNo');
    params.append('PropertyNo', formData?.Property?.value);
    params.append('UnitRefNo', selectedOption?.value);
    params.append('CustomerType', 'NoInternal');
    const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params?.toString()}`);
    setUntData(res?.data?.result?.data);
    let item = res?.data?.result?.data;
    const taxCode = taxCodeList?.find((dep) => dep.text === item?.VatDescription);

    const additionalParam = new URLSearchParams();
    additionalParam.append('Action', 'GetChargesDetails');
    additionalParam.append('RentPerAnnum', item?.Rent_Per_Annum);
    const Additionalres = await apiService.getApiParamater('GET_UNITNO_DATA', `?${additionalParam?.toString()}`);
    setAdditionalCharges(Additionalres?.data?.result?.data);
    // const mergedData = { ...item, ...Additionalres?.data?.result?.data };
    // setAdditionalCharges(mergedData);
    const taxParam = new URLSearchParams();
    taxParam.append('Action', 'GetTaxRecordIdByTaxName');
    taxParam.append('TaxDescription', item?.VatDescription);
    const taxrecord = await apiService.getApiParamater('GET_UNITNO_DATA', `?${taxParam?.toString()}`);
    let recordId = taxrecord?.data?.result?.data?.RecordId;
    let Rate = taxrecord?.data?.result?.data?.Rate;

    const periodParam = new URLSearchParams();
    periodParam.append('Action', 'GetRentforPeriod');
    periodParam.append('PeriodFrom', periodFrom);
    periodParam.append('PeriodTo', periodTo);
    periodParam.append('RentPerAnnum', item?.Rent_Per_Annum);
    const periodRes = await apiService.getApiParamater('GET_UNITNO_DATA', `?${periodParam?.toString()}`);
    let resPeriod = periodRes?.data?.result?.data;
    let taxAmount = (resPeriod?.RentPerPeriod * Rate) / 100;
    let totalAmount = resPeriod?.RentPerPeriod + taxAmount;

    setFormData({
      ...formData,
      vatRecord: recordId,
      taxRate: Rate,
      Unit: selectedOption,
      noCommunity: '',
      rentPerAnum: item?.Rent_Per_Annum?.toFixed(currencyPrecision?.decimalNumbers),
      unitClass: item?.Unit_Class,
      type: item?.Unit_Type,
      rentForPeriod: resPeriod?.RentPerPeriod?.toFixed(currencyPrecision?.decimalNumbers),
      unitRefNo: item?.Ref_No,
      rentAmount: resPeriod?.RentPerPeriod,
      bedRooms: item?.Bedrooms === '0' ? '' : item?.Bedrooms,
      FreeRent: '',
      discountPerc: '',
      totalArea: item?.Total_Area === '0' ? '' : item?.Total_Area,
      Landloard: item?.Landlord === '0' ? '' : item?.Landlord,
      taxCode: { label: taxCode?.text, value: taxCode?.value },
      category: item?.Unit_Category,
      vat: taxAmount,
      discount: 0,
      total: totalAmount,
      parkingNo: item?.ParkingNo === '0' ? '' : item?.ParkingNo,
      munAcNo: item?.MuncAcNo === '0' ? '' : item?.MuncAcNo,
      Parking: item?.Parking === '0' ? '' : item?.Parking,
    });
  };
  const handleSave = async () => {
    try {
      setloader(true);
      if (!transData?.noInstallment) {
        toast.warning(`Please Enter No of Installment`);
        setloader(false);
        return;
      } else if (!transData?.CustomerAccount?.label) {
        toast.warning(`Please Select Primary Tenant`);
        setloader(false);
        return;
        // } else if (!transData?.leaseAgent?.label) {
        //   toast.warning(`Please Select Lease Agent`);
        //   setloader(false);
        //   return;
      } else if (!dataList[0]?.Property?.label) {
        toast.warning(`Please Select Unit details`);
        setloader(false);
        return;
      }
      //  else if (!transData?.remarks2) {
      //   toast.warning(`Please Enter Remarks`);
      //   setloader(false);
      //   return;
      // }
      const currentDatetimeUTC = new Date().toISOString();
      const unitDetailsList = await Promise.all(
        dataList.map(async (item) => {
          const validation = new URLSearchParams();
          validation.append('Action', 'CheckAgreementValidPeriod');
          validation.append('PeriodFrom', periodFrom);
          validation.append('PeriodTo', periodTo);
          validation.append('PropertyName', item?.Property?.label);
          validation.append('UnitNo', item?.Unit?.label);
          validation.append('UnitRefNo', item?.unitRefNo);

          const validRes = await apiService.getApiParamater('GET_UNITNO_DATA', `?${validation?.toString()}`);

          if (validRes?.data?.result?.data?.Count > 0) {
            toast.warning(`Selected Unit ${item?.Unit?.label} Already Existed in lease Aggrement, in Given ${transData?.periodFrom} to ${transData?.periodTo}`);
            return null;
          }

          return {
            recordId: 0,
            leaseNo: '0',
            groupId: 0,
            proposalNo: '0',
            propertyNo: item?.Property?.value,
            propertyName: item?.Property?.label,
            unitNo: item?.Unit?.label,
            unitRefNo: item?.unitRefNo,
            unitClass: item?.unitClass,
            totalArea: parseFloat(item?.totalArea || 0),
            rentPerAnnum: parseFloat(item?.rentPerAnum),
            periodRent: parseFloat(item?.rentForPeriod),
            discountPercent: parseFloat(item?.discountPerc) || 0,
            discount: parseFloat(item?.FreeRent) || 0,
            rent: parseFloat(item?.rentForPeriod),
            vat: parseFloat(item?.vat),
            total: parseFloat(item?.total),
            taxCode: parseInt(item?.vatRecord),
            taxPercent: parseFloat(item?.taxRate),
            landlord: item?.Landloard || '0',
            municipalityNo: item?.munAcNo || '0',
            createdBy: userName,
            createdOn: currentDatetimeUTC,
            isAdded: true,
            isUpdated: false,
            rentNL: false,
          };
        }),
      );
      const formattedRows = unitDetailsList.filter(Boolean);
      if (formattedRows.length === 0) {
        setloader(false);
        return;
      }
      const selectedAdditional = additionalCharges?.filter((acc) => acc.isSelected === true);

      const additionalChargesList = selectedAdditional.map((item, index) => ({
        recordId: 0,
        leaseNo: '0',
        groupId: 0,
        description: item?.Description,
        mId: item?.RecordId,
        drAcCode: transData?.CustomerAccount?.label,
        drAcName: transData?.CustomerName?.label,
        crAcCode: item?.AccountCode,
        crAcName: item?.CreditAccount,
        taxCode: item?.TaxCode,
        taxInclusive: item?.TaxInclusive,
        amount: item?.Amount,
        vat: item?.VAT,
        total: item?.Total,
        remarks: item?.Remarks,
        posting: item?.Posting,
        isDeposit: item?.IsDeposit,
        status: '0',
        psdId: 0,
        propertyNo: dataList[0]?.Property?.value,
        propertyName: dataList[0]?.Property?.label,
        unitNo: dataList[0]?.Unit?.label,
        unitRefNo: dataList[0]?.unitRefNo,
        tenantNo: transData?.CustomerAccount?.label,
        tenantName: transData?.CustomerName?.label,
        category: '',
        receiptNo: '0',
        receiptDate: currentDatetimeUTC,
        voucherNo: '0',
        voucherDate: currentDatetimeUTC,
        financialYear: financialYear,
        exp1: '0',
        exp2: '0',
        exp3: '0',
        exp4: '0',
        exp5: '0',
        modifiedBy: userName,
        modifiedOn: currentDatetimeUTC,
        createdBy: userName,
        createdOn: currentDatetimeUTC,
        vatDescription: item?.VATDescription,
        isChecked: true,
      }));
      const leaseAgreementMaster = {
        record_Id: 0,
        leaseNo: '0',
        leaseDate: periodFrom,
        leaseExpiry: periodTo,
        status: '0',
        tenantNo: transData?.CustomerAccount?.label,
        tenantName: transData?.CustomerName?.label,
        tenantTradeName: '',
        tenantBrand: '',
        totalArea: 0,
        totalAmount: 0,
        totalAmountByUser: 0,
        leaseTerm: leaseTerm?.toString(),
        leaseTermInMonths: parseInt(transData?.leaseTerm / 30),
        paymentTerm: '',
        paymentTermNoOfChqs: transData?.noInstallment,
        group_Id: 0,
        discountPercent: 0,
        discount: 0,
        taxCode: 0,
        taxInclusive: false,
        vatPercent: 0,
        stPercent: 0,
        st: 0,
        vat: 0,
        rent: 0,
        total: 0,
        modifiedBy: userName,
        modifiedOn: currentDatetimeUTC,
        createdBy: userName,
        createdOn: currentDatetimeUTC,
        transactionDate: transData?.transectionDate,
        rentFreeDays: 0,
        rentFreeAmount: 0,
        remarks: transData?.remarks2 || '0',
        arabicRemarks: transData?.arabicRemarks || '',
        leasingAgent: transData?.leaseAgent?.label || '',
        brokerName: transData?.Broker?.label || '',
        outletName: '',
      };
      const body = {
        leaseMain: {
          leaseAgreementMaster: leaseAgreementMaster,
          unitDetailsList: formattedRows,
          additionalChargesList: additionalChargesList,
          custPri_ContactNo: transData?.CustomerAccount?.value?.ContactNo?.toString() || '',
          custPri_Email: transData?.CustomerAccount?.value?.Email || '',
          custPri_PassportID: transData?.CustomerAccount?.value?.IDNo?.toString() || '',
          custPri_Nationality: transData?.CustomerAccount?.value?.Nationality?.toString() || '',
          custPri_VatRegNo: transData?.CustomerAccount?.value?.VATRegNo?.toString() || '',
          custJoint_CustNo: transData?.JointCustomerAccount?.label || '',
          custJoint_CustName: transData?.JointCustomerName?.label || '',
          custJoint_ContactNo: transData?.JointCustomerAccount?.value?.ContactNo?.toString() || '',
          custJoint_Email: transData?.JointCustomerAccount?.value?.Email || '',
          custJoint_PassportID: transData?.JointCustomerAccount?.value?.IDNo?.toString() || '',
          custJoint_Nationality: transData?.JointCustomerAccount?.value?.Nationality?.toString() || '',
          custJoint_VatRegNo: transData?.JointCustomerAccount?.value?.VATRegNo?.toString() || '',
        },
      };
      const postRes = await apiService.post('CREATE_LEASE_AGRE', body);
      if (postRes?.data?.statusCode === 201) {
        const token = localStorage.getItem('Token');
        const DB = localStorage.getItem('DataBase');
        if (!token) {
          alert('Auth token is missing! Unable to proceed.');
          return;
        }
        // const popupWidth = 1000;
        // const popupHeight = 600;
        // const popupLeft = (window.screen.width - popupWidth) / 2;
        // const popupTop = (window.screen.height - popupHeight) / 2;
        // const popup = window.open(
        //   "",
        //   "ReportPopup",
        //   `width=${popupWidth},height=${popupHeight},left=${popupLeft},top=${popupTop},resizable=yes,scrollbars=yes`
        // );

        // const newTab = window.open("Lease_Residiential/Print", "Lease_Residiential");
        // if (newTab) {
        //   const form = document.createElement("form");
        //   form.method = "POST";
        //   form.action = "https://procreports.apps.pro360erp.com/rdlreport/webform/DownloadDocPrints.aspx";
        //   form.target = "ReportPopup";

        //   const inputs = [
        //     { name: "authToken", value: token },
        //     { name: "_db", value: DB },
        //     { name: "reportName", value: "LeaseDocument" },
        //     { name: "LeaseNo", value: postRes?.data?.result?.leaseNo },
        //   ];

        //   inputs.forEach(({ name, value }) => {
        //     const input = document.createElement("input");
        //     input.type = "hidden";
        //     input.name = name;
        //     input.value = value;
        //     form.appendChild(input);
        //   });

        //   document.body.appendChild(form);
        //   form.submit();
        //   document.body.removeChild(form);
        // }
        toast.success(`${postRes?.data?.result?.leaseNo} Created successfully`);
        setloader(false);
        if (onSaved) {
          onSaved();
        } else {
          navigate('/Lease/Management/Lease/Agreement/Listing');
        }
      } else {
      }

      setloader(false);
    } catch (error) {
      setloader(false);

      console.error('Error Save Data', error);
    }
  };
  const formatDate = (date) => {
    if (!date) return null;
    const d = new Date(date);
    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0'); // month is 0-based
    const day = String(d.getDate()).padStart(2, '0');
    return `${year}-${month}-${day}`;
  };
  useEffect(() => {
    const { periodFrom: formattedToday, periodTo: formattedNextYear } = getDefaultPeriodDates();
    const defaultLeaseTerm = calculateDaysDifference(formattedToday, formattedNextYear);

    setPeriodFrom(formattedToday);
    setPeriodTo(formattedNextYear);
    setTransData(getEmptyTransData(formattedToday, formattedNextYear, defaultLeaseTerm));
    setLeaseTerm(defaultLeaseTerm);
  }, []);
  const handlePeriodToChange = ({ name, value }) => {
    const newToDate = value;
    if (new Date(newToDate) <= new Date(periodFrom)) {
      toast.warning('Period To date cannot be earlier than Period From date.');
      return;
    }
    const formattedDate = formatDate(newToDate);
    setPeriodTo(formattedDate);
    setLeaseTerm(calculateDaysDifference(periodFrom, formattedDate));
  };
  const handlePeriodFromChange = ({ name, value }) => {
    const newFromDate = value;
    const newToDate = new Date(newFromDate - 1);
    newToDate.setFullYear(newToDate.getFullYear() + 1);

    const formattedFrom = formatDate(newFromDate);
    const formattedTo = formatDate(newToDate);

    const nextYear = new Date(newFromDate);
    nextYear.setFullYear(newFromDate.getFullYear() + 1);
    nextYear.setDate(nextYear.getDate() - 1);
    const formattedToday = newFromDate.toISOString().split('T')[0];
    const formattedNextYear = nextYear.toISOString().split('T')[0];

    setPeriodFrom(formattedFrom);
    setPeriodTo(formattedNextYear);
    setLeaseTerm(calculateDaysDifference(formattedFrom, formattedNextYear));
  };
  const handleInputChange = ({ name, value }) => {
    if (name === 'transectionDate') {
      if (new Date(value) > new Date(periodFrom)) {
        toast.warning(`Transaction Date should be earlier than Period From`);
        return;
      }
      setTransData({ ...transData, [name]: formatDate(value) });
    }
    setTransData({ ...transData, [name]: value });
  };
  const handlefieldChange = (e) => {
    const { name, value } = e.target;
    if (name === 'noInstallment') {
      if (value === '0') {
        toast.warning('No of Installment must be grater then or equal to "1');
        return;
      }
      if (dataList?.length > 0) {
        handlePaymentPlan(dataList);
      }
    }
    setTransData({ ...transData, [e.target.name]: e.target.value });
  };
  const handleCustomer = async (selectedOption) => {
    if (transData?.JointCustomerName?.label === selectedOption?.label) {
      toast?.warning(`Primary Customer Should be Different from Joint `);
      return;
    } else {
      const params = new URLSearchParams();
      params.append('Action', 'GetCustomerDetailsByTenantNo');
      params.append('TenantNo', selectedOption?.value);
      const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
      setTransData({
        ...transData,
        CustomerName: selectedOption,
        CustomerAccount: { label: selectedOption?.value, value: res?.data?.result?.data },
      });
    }
  };
  const handleCustomerAccount = async (selectedOption) => {
    if (transData?.JointCustomerAccount?.label === selectedOption?.label) {
      toast?.warning(`Primary Customer Should be Different from Joint `);
      return;
    } else {
      const params = new URLSearchParams();
      params.append('Action', 'GetCustomerDetailsByTenantNo');
      params.append('TenantNo', selectedOption?.label);
      const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
      setTransData({
        ...transData,
        CustomerAccount: { label: selectedOption?.label, value: res?.data?.result?.data },
        CustomerName: { label: selectedOption?.value, value: selectedOption?.label },
      });
    }
  };
  const handleJointCustomer = async (selectedOption) => {
    if (transData?.CustomerName?.label === selectedOption?.label) {
      toast?.warning(`Joint Customer Should be Different from Primary`);
      return;
    } else {
      const params = new URLSearchParams();
      params.append('Action', 'GetCustomerDetailsByTenantNo');
      params.append('TenantNo', selectedOption?.value);
      const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
      setTransData({
        ...transData,
        JointCustomerName: selectedOption,
        JointCustomerAccount: { label: selectedOption?.value, value: res?.data?.result?.data },
      });
    }
  };
  const handleJointCustomerAccount = async (selectedOption) => {
    if (transData?.CustomerAccount?.label === selectedOption?.label) {
      toast?.warning(`Joint Customer Should be Different from Primary`);
      return;
    } else {
      const params = new URLSearchParams();
      params.append('Action', 'GetCustomerDetailsByTenantNo');
      params.append('TenantNo', selectedOption?.label);
      const res = await apiService.getApiParamater('GET_UNITNO_DATA', `?${params.toString()}`);
      setTransData({
        ...transData,
        JointCustomerAccount: { label: selectedOption?.label, value: res?.data?.result?.data },
        JointCustomerName: { label: selectedOption?.value, value: selectedOption?.label },
      });
    }
  };
  const handleAgentChange = (selectedOption) => {
    setTransData({
      ...transData,
      leaseAgent: selectedOption,
    });
  };
  const handleBrokerChange = (selectedOption) => {
    setTransData({
      ...transData,
      Broker: selectedOption,
    });
  };
  const handleRemarksChange = (selectedOption) => {
    setTransData({
      ...transData,
      remarks: selectedOption,
      remarks2: selectedOption?.value,
    });
  };
  const handleCheckboxChange = async (index, field, value) => {
    const updated = [...additionalCharges];
    updated[index][field] = value;
    let data = updated[index];
    // If it's the select checkbox, also manage isSelected
    if (field === 'isSelected') {
      updated[index].isSelected = value;
    }
    if (field === 'Rate') {
      let qty = parseFloat(data?.Qty) || 0;
      let vatdes = data?.VATDescription;
      let amount = parseFloat(value) * qty;
      if (vatdes) {
        const taxParam = new URLSearchParams();
        taxParam.append('Action', 'GetTaxRecordIdByTaxName');
        taxParam.append('TaxDescription', vatdes);
        const taxrecord = await apiService.getApiParamater('GET_UNITNO_DATA', `?${taxParam.toString()}`);
        const result = taxrecord?.data?.result?.data;
        let VATRate = result?.Rate || 0; // Save VAT % for future calc
        const vat = (parseFloat(amount || 0) * VATRate) / 100;
        let VAT = vat;
        let Total = parseFloat(amount || 0) + vat;
        updated[index].Rate = value;
        updated[index].VATRate = VATRate || 0;
        updated[index].VAT = VAT;
        updated[index].Amount = amount;
        updated[index].Total = Total;
      } else {
        const vat = (parseFloat(amount || 0) * 0) / 100;
        let VAT = vat;
        let Total = parseFloat(amount || 0) + vat;
        updated[index].Rate = value?.toFixed(currencyPrecision?.decimalNumbers);
        updated[index].Amount = amount;
        updated[index].Total = Total;
      }
    }
    if (field === 'Qty') {
      let rate = parseFloat(data?.Rate) || 0;
      let vatdes = data?.VATDescription;
      let amount = parseFloat(value) * rate;
      if (vatdes) {
        const taxParam = new URLSearchParams();
        taxParam.append('Action', 'GetTaxRecordIdByTaxName');
        taxParam.append('TaxDescription', vatdes);
        const taxrecord = await apiService.getApiParamater('GET_UNITNO_DATA', `?${taxParam.toString()}`);
        const result = taxrecord?.data?.result?.data;
        let VATRate = result?.Rate || 0; // Save VAT % for future calc
        const vat = (parseFloat(amount || 0) * VATRate) / 100;
        let VAT = vat;
        let Total = parseFloat(amount || 0) + vat;
        updated[index].Qty = value;
        updated[index].VATRate = VATRate;
        updated[index].VAT = VAT;
        updated[index].Amount = amount;
        updated[index].Total = Total;
      } else {
        const vat = (parseFloat(amount || 0) * 0) / 100;
        let VAT = vat?.toFixed(currencyPrecision?.decimalNumbers);
        let Total = parseFloat(amount || 0) + vat;
        updated[index].Qty = value;
        updated[index].Amount = amount;
        updated[index].VAT = VAT;
        updated[index].Total = Total;
      }
    }
    setAdditionalCharges(updated);
  };
  const handleVatChange = async (index, selectedValue) => {
    const selectedOption = taxCodeList.find((tc) => tc.value === selectedValue);
    if (!selectedOption) return;

    const taxParam = new URLSearchParams();
    taxParam.append('Action', 'GetTaxRecordIdByTaxName');
    taxParam.append('TaxDescription', selectedOption.text);

    try {
      const taxrecord = await apiService.getApiParamater('GET_UNITNO_DATA', `?${taxParam.toString()}`);
      const result = taxrecord?.data?.result?.data;
      debugger;
      if (result) {
        setAdditionalCharges((prev) => {
          const updated = [...prev];
          const row = { ...updated[index] };

          row.TaxCodeValue = selectedValue;
          row.VATDescription = selectedOption.text;
          row.VATRate = result.Rate; // Save VAT % for future calc
          debugger;
          const vat = (parseInt(row.Amount) * result.Rate) / 100;
          row.VAT = vat;
          row.Total = parseInt(row.Amount) + vat;
          debugger;
          updated[index] = row;
          return updated;
        });
      }
    } catch (error) {
      console.error('Failed to fetch VAT data:', error);
    }
  };
  const preventNegativeSign = (e) => {
    if (e.key === '-' || e.key === '+') {
      e.preventDefault();
    }
  };
  const handlePaymentPlan = async (rowData) => {
    const leaseRows = rowData?.length > 0 ? rowData : [rowData];
    const totalRent = leaseRows?.reduce((sum, row) => sum + (parseFloat(row?.rentAmount) || 0), 0);
    const total = leaseRows?.reduce((sum, row) => sum + (parseFloat(row?.total) || 0), 0);
    const vat = leaseRows?.reduce((sum, row) => sum + (parseFloat(row?.vat) || 0), 0);
    // comma separated values
    const propertyNos = [...new Set(leaseRows.map((i) => i.Property?.value).filter(Boolean))].join(',');
    const propertyNames = [...new Set(leaseRows.map((i) => i.Property?.label).filter(Boolean))].join(',');
    const unitNos = [...new Set(leaseRows.map((i) => i.Unit?.label).filter(Boolean))].join(',');
    const taxCodes = [...new Set(leaseRows.map((i) => i.taxCode?.value).filter(Boolean))].join(',');
    const taxPercents = [...new Set(leaseRows.map((i) => i.taxRate).filter((v) => v !== undefined))].join(',');

    const params = new URLSearchParams();
    params.append('PropertyNo', propertyNos);
    params.append('PropertyName', propertyNames);
    params.append('UnitNo', unitNos);
    params.append('TaxCode', taxCodes);
    params.append('VATPercent', taxPercents);
    params.append('PeriodFrom', periodFrom);
    params.append('PeriodTo', periodTo);
    params.append('Rent', totalRent);
    params.append('VatAmount', vat);
    params.append('TotalAmount', total);
    params.append('DecimalFormat', currencyPrecision?.decimalNumbers || 2);
    params.append('PaymentTermNoOfChqs', parseInt(transData?.noInstallment) || 2);
    params.append('IsEdit', false);
    params.append('PayId', '');
    params.append('CreatedBy', userName);
    params.append('STPercent', 0.0);
    const res = await apiService.getApiParamater('GET_PAYMENT_PLAN', `?${params?.toString()}`);
    // API returns an array for multiple installments, a single object for one row — always keep full payload (never data[0]).
    const planData = res?.data?.result?.data;
    setInvoiceList(planData == null ? [] : planData);
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      navigate('/Lease/Management/Lease/Agreement/Listing');
    }
  };
  return (
    <Modal show={show} onHide={handleClose} size="xl" scrollable centered backdrop="static" keyboard={false}>
      <Modal.Header closeButton>
        <Modal.Title>Lease Agreement</Modal.Title>
      </Modal.Header>
      <Modal.Body>
      <div className="d-flex mb-3">
        <div className="col-lg-8 nav nav-pills overslid d-flex gap-4">
          <div className={`dashitems sidebar-text center ${activeTab === 0 ? 'sideActive' : ''}`} onClick={() => handleTabClick(0)}>
            Transaction and Tenant
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 1 ? 'sideActive' : ''}`} onClick={() => handleTabClick(1)}>
            Unit Details
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 2 ? 'sideActive' : ''}`} onClick={() => handleTabClick(2)}>
            Additional Charges
          </div>
          <div className={`dashitems sidebar-text center  ${activeTab === 3 ? 'sideActive' : ''}`} onClick={() => handleTabClick(3)}>
            Payment Plan
          </div>
        </div>
      </div>
      {gridVisibility[0] && (
        <div className="">
          <div className="cost-center-section mt-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setFilterTab(!FilterTab)}>
              <div className="h6 pt-1">Transaction Details</div>
            </div>
            <div className={`slide-content ${FilterTab ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${FilterTab ? 'slide-in' : 'slide-out'}`}>
                <div className="form-group grid-contain ">
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Transaction Date
                    </label>
                    <DatePicker
                      todayButton="Today"
                      selected={transData?.transectionDate}
                      onChange={(date) => handleInputChange({ name: 'transectionDate', value: date })}
                      dateFormat="dd-MMM-yyyy"
                      className="p-2 form-control w-100"
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="periodFrom" className="form-label pt-1 start">
                      Period From
                    </label>
                    <DatePicker
                      todayButton="Today"
                      selected={periodFrom}
                      onChange={(date) => handlePeriodFromChange({ name: 'periodFrom', value: date })}
                      dateFormat="dd-MMM-yyyy"
                      className="p-2 form-control w-100"
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="periodTo" className="form-label pt-1 start">
                      Period To
                    </label>
                    <DatePicker
                      todayButton="Today"
                      selected={periodTo}
                      onChange={(date) => handlePeriodToChange({ name: 'periodTo', value: date })}
                      dateFormat="dd-MMM-yyyy"
                      className="p-2 form-control w-100"
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="leaseTerm" className="form-label pt-1 start">
                      Lease Term
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="leaseTerm" value={leaseTerm} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      No. Of Installments
                    </label>
                    <input
                      type="number"
                      className="p-2 form-control w-75"
                      name="noInstallment"
                      min={1}
                      value={transData?.noInstallment}
                      onChange={handlefieldChange}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Select Remarks
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={transData.remarks}
                      options={remarksList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                      onChange={(selectedOption) => handleRemarksChange(selectedOption)}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Remarks
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="remarks2" onChange={handlefieldChange} value={transData?.remarks2} />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Arabic Remarks
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="arabicRemarks" onChange={handlefieldChange} value={transData?.arabicRemarks} />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cost-center-section mt-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setTanantTab(!tentantTab)}>
              <div className="h6 pt-1">Tenant Primary Details</div>
            </div>
            <div className={`slide-content ${tentantTab ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${tentantTab ? 'slide-in' : 'slide-out'}`}>
                <div className="form-group grid-contain ">
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Name
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={transData.CustomerName}
                      options={customerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                      onChange={(selectedOption) => handleCustomer(selectedOption)}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Acc/ Code
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={transData.CustomerAccount}
                      options={customerList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                      onChange={(selectedOption) => handleCustomerAccount(selectedOption)}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Contact No.
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.CustomerAccount?.value?.ContactNo} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Email
                    </label>
                    <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.CustomerAccount?.value?.Email} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Passport / ID
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="installments" value={transData?.CustomerAccount?.value?.IDNo} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Nationality
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.Nationality} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Vat Reg No
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.CustomerAccount?.value?.VATRegNo} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Leasing Agent
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={transData.leaseAgent}
                      options={leasingAgent?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                      onChange={(selectedOption) => handleAgentChange(selectedOption)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="cost-center-section my-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setTanantJoint(!tentantJoint)}>
              <div className="h6 pt-1">Tenant Joint Details</div>
            </div>
            <div className={`slide-content ${tentantJoint ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${tentantJoint ? 'slide-in' : 'slide-out'}`}>
                <div className="form-group grid-contain ">
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Name
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={transData.JointCustomerName}
                      options={customerList?.map((cost) => ({ value: cost?.value, label: cost?.text }))}
                      onChange={(selectedOption) => handleJointCustomer(selectedOption)}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Acc/ Code
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={transData.JointCustomerAccount}
                      options={customerList?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                      onChange={(selectedOption) => handleJointCustomerAccount(selectedOption)}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Contact No.
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="periodto" value={transData?.JointCustomerAccount?.value?.ContactNo} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Email
                    </label>
                    <input type="email" className="p-2 form-control w-75" name="leaseTerm" value={transData?.JointCustomerAccount?.value?.Email} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Passport / ID
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="installments" readOnly value={transData?.JointCustomerAccount?.value?.IDNo} />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Nationality
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.JointCustomerAccount?.value?.Nationality} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Vat Reg No
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="remarks" value={transData?.JointCustomerAccount?.value?.VATRegNo} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Broker
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={transData.Broker}
                      options={leasingAgent?.map((cost) => ({ value: cost?.text, label: cost?.value }))}
                      onChange={(selectedOption) => handleBrokerChange(selectedOption)}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
      {gridVisibility[1] && (
        <>
          <div className="cost-center-section my-3">
            <div className="d-flex cursor-pointer slide-header" onClick={() => setUnitRent(!unitRent)}>
              <div className="h6 pt-1">Unit Rent Details</div>
            </div>
            <div className={`slide-content ${unitRent ? 'open' : 'closed'}`}>
              <div className={`border-box2 p-3 ${unitRent ? 'slide-in' : 'slide-out'}`}>
                <div className="form-group grid-contain ">
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Property
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={formData.Property}
                      options={propertylist?.map((cost) => ({
                        value: cost?.value,
                        label: cost?.text,
                      }))}
                      onChange={(selectedOption) => handlePropertyChange(selectedOption)}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Unit *
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={formData.Unit}
                      options={unitList?.map((cost) => ({
                        value: cost?.value,
                        label: cost?.text,
                      }))}
                      onChange={(selectedOption) => handleUnitChange(selectedOption)}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Munc <br />
                      No.community{' '}
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="noCommunity" value={formData.noCommunity} onChange={handleChange} />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Rent Per Anum
                    </label>
                    <input type="email" className="p-2 form-control w-75" name="rentPerAnum" value={formData.rentPerAnum} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Unit Class
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="unitClass" value={formData.unitClass} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Type
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="type" value={formData.type} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Rent For period
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="rentForPeriod" value={formData.rentForPeriod} onChange={handleChange} />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Unit Ref No.
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="unitRefNo" value={formData.unitRefNo} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Bed Room’s
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="bedRooms" value={formData.bedRooms} readOnly />
                  </div>
                  <div className="d-flex gap-2">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Free Rent
                    </label>
                    <input
                      type="number"
                      className="p-2 form-control w-25"
                      name="discountPerc"
                      placeholder="%"
                      value={formData.discountPerc}
                      onChange={handleChange}
                    />
                    <input
                      type="number"
                      className="p-2 form-control w-50"
                      name="FreeRent"
                      placeholder="0.000"
                      value={formData.FreeRent}
                      onChange={handleChange}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Landlord
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="Landloard" value={formData.Landloard} onChange={handleChange} />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Category
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="category" value={formData.category} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Tax Code *
                    </label>
                    <Select
                      theme={(theme) => ({
                        ...theme,
                        borderRadius: 5,
                        padding: 9,
                      })}
                      menuPortalTarget={document.body}
                      styles={{
                        menuPortal: (base) => ({ ...base, zIndex: 9999 }),
                        option: (provided, state) => ({
                          ...provided,
                          backgroundColor: state.isFocused ? '#F5F5F5 ' : null,
                          color: state.isFocused ? '#000 ' : '#000',
                          ':hover': {
                            backgroundColor: '#F5F5F5',
                            color: '#000 ',
                          },
                        }),
                      }}
                      className="w-75 p-0"
                      value={formData.taxCode}
                      options={taxCodeList?.map((cost) => ({
                        value: cost?.value,
                        label: cost?.text,
                      }))}
                      onChange={(selectedOption) => handleTaxChange(selectedOption)}
                    />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Total Area
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="totalArea" value={formData.totalArea} readOnly />
                  </div>
                  <div className="d-flex gap-4 center">
                    <input
                      className="form-check-input"
                      type="checkbox"
                      id="rentCheck"
                      style={{ width: '20px', height: '20px' }}
                      name="rentCheck"
                      checked={rentCheck}
                      onChange={(e) => setRentCheck(e.target.checked)}
                    />
                    <label className="text-danger">Rent-Non Leasing</label>
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      VAT
                    </label>
                    <input type="text" className="p-2 form-control w-75" name="vat" value={formData.vat} readOnly />
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Munc / Ac No.{' '}
                    </label>
                    <input type="number" className="p-2 form-control w-75" name="munAcNo" value={formData.munAcNo} onChange={handleChange} />
                  </div>
                  <div className="d-flex center">
                    <h6 className="text-danger text-bold">Unit Rent</h6>
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      Total
                    </label>
                    <input
                      type="number"
                      className="p-2 form-control w-75"
                      name="total"
                      value={formData?.total?.toFixed(currencyPrecision?.decimalNumbers)}
                      readOnly
                    />
                  </div>
                  <div className="d-flex">
                    <label className="form-label pt-1 start">Months</label>
                    <select className="p-2 form-control w-75" value={formData.month} name="month" onChange={handleChange}>
                      <option style={{ height: '100px' }} value="">
                        Select Month
                      </option>
                      {[...Array(24)].map((_, i) => (
                        <option style={{ height: '100px' }} key={i + 1} value={i + 1}>
                          {i + 1}
                        </option>
                      ))}
                    </select>
                  </div>
                  <div className="d-flex">
                    <label htmlFor="validationCustom01" className="form-label pt-1 start">
                      increment
                    </label>
                    <input
                      type="number"
                      className="p-2 form-control w-75"
                      name="increment"
                      placeholder="%"
                      value={formData.increment}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div className="d-flex">
            {editIndex !== null ? (
              <div className="mainbtnSecondary flex-end gap-2" onClick={handleUpdate}>
                <GrDocumentUpdate color="#fff" className="center mt-2 mx-2" />
                <div className="center">Update</div>
              </div>
            ) : (
              <div className="mainbtn end center gap-2" onClick={handleAdd} disabled={showUpdate}>
                <IoAdd color="#fff" className="center mx-2" />
                <div className="center">Add</div>
              </div>
            )}
          </div>
          <div>
            <div className="table-container my-3" style={{ overflowX: 'auto', height: '400px' }}>
              <table>
                <thead className="dynoTable">
                  <tr>
                    <th>Action</th>
                    <th>Property</th>
                    <th>Unit No.</th>
                    <th>Unit Ref No.</th>
                    <th>Unit Class</th>
                    <th>Area</th>
                    <th>Discount</th>
                    <th>Tax</th>
                    <th>Rent</th>
                    <th>VAT</th>
                    <th>Total</th>
                    <th>Months</th>
                    <th>Increment %</th>
                    <th>Rent Per Anum</th>
                    <th>Bed Room’s</th>
                    <th>Unit Type</th>
                    <th>Unit Category</th>
                    <th>Parking No</th>
                    <th>Munc A/c No.</th>
                    <th>Munc No. Community</th>
                  </tr>
                </thead>
                <tbody>
                  {Array.isArray(dataList) &&
                    dataList?.map((data, index) => (
                      <tr key={index}>
                        <td className="gap-3 d-flex">
                          {!data.Property?.label ? (
                            <input className="p-1" disabled style={{ width: '80px' }} />
                          ) : (
                            <>
                              <div className="pt-2" onClick={() => handleDelete(index)}>
                                <MdDelete size={25} />
                              </div>
                              <div className="pt-2" onClick={() => handleEdit(index)}>
                                <FiEdit size={25} />
                              </div>
                            </>
                          )}
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.Property?.label || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.Unit.label || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.unitRefNo || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.unitClass || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.totalArea)?.toFixed(currencyPrecision?.decimalNumbers) || ''}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.FreeRent)?.toFixed(currencyPrecision?.decimalNumbers) || ''}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.taxCode?.label || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.rentAmount)?.toFixed(currencyPrecision?.decimalNumbers) || ''}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.vat)?.toFixed(currencyPrecision?.decimalNumbers) || 0}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.total)?.toFixed(currencyPrecision?.decimalNumbers) || ''}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.month || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.increment || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input
                            className="p-1"
                            value={Number(data.rentPerAnum)?.toFixed(currencyPrecision?.decimalNumbers)}
                            disabled
                            style={{ width: '130px' }}
                          />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.bedRooms || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.type || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.category || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.parkingNo || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.munAcNo || ''} disabled style={{ width: '130px' }} />
                        </td>
                        <td className="m-0 p-0">
                          <input className="p-1" value={data.noCommunity || ''} disabled />
                        </td>
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
            <div className="d-flex justify-content-between boxs">
              <div className="d-flex gap-2">
                <div className="totalhead center">Total Units</div>
                <div className="field">{dataList?.length || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Discount</div>
                <div className="field">{`${totalDiscount}` || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Vat Total</div>
                <div className="field">{totalVat || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Rent Total</div>
                <div className="field">{totalRent || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Total Amount</div>
                <div className="field">{calculatedTotal || '---'}</div>
              </div>
              <div className="d-flex gap-2">
                <div className="totalhead center">Rent Per Anum Total</div>
                <div className="field">{rentPerAnum || '---'}</div>
              </div>
            </div>
          </div>
        </>
      )}
      {gridVisibility[2] && (
        <div className="table-container my-3" style={{ overflowX: 'auto', height: '700px' }}>
          <table>
            <thead className="dynoTable">
              <tr>
                <th>Select</th>
                <th>Description</th>
                <th>Rate</th>
                <th>Qty</th>
                <th>Amount</th>
                <th>Tax Code</th>
                <th>Vat</th>
                <th>Total</th>
                <th>Posting</th>
                <th>Remarks</th>
                <th>From Rent</th>
              </tr>
            </thead>
            <tbody>
              {additionalCharges?.map((row, index) => (
                <tr key={row.RecordId}>
                  {/* Select */}
                  <td className="m-0 p-0 text-center">
                    <div className="center mt-1">
                      <input
                        type="checkbox"
                        className="center"
                        checked={row.isSelected || false}
                        onChange={(e) => handleCheckboxChange(index, 'isSelected', e.target.checked)}
                        style={{ width: '20px', height: '20px' }}
                      />
                    </div>
                  </td>

                  {/* Description */}
                  <td className="m-0 p-0">
                    <input className="p-1" value={row.Description} disabled style={{ width: '400px' }} />
                  </td>

                  {/* Rate */}
                  <td className="m-0 p-0">
                    <input
                      className="p-1"
                      type="number"
                      onKeyDown={preventNegativeSign}
                      value={row.Rate || ''}
                      onChange={(e) => handleCheckboxChange(index, 'Rate', e.target.value)}
                      style={{ width: '100px' }}
                    />
                  </td>

                  {/* Qty */}
                  <td className="m-0 p-0">
                    <input
                      className="p-1"
                      onKeyDown={preventNegativeSign}
                      type="number"
                      value={row.Qty || ''}
                      onChange={(e) => handleCheckboxChange(index, 'Qty', e.target.value)}
                      style={{ width: '100px' }}
                    />
                  </td>

                  {/* Amount */}
                  <td className="m-0 p-0">
                    <input
                      className="p-1"
                      type="text"
                      value={row.Amount >= 0 ? row?.Amount?.toFixed(currencyPrecision?.decimalNumbers) : '0.000'}
                      disabled
                      style={{ width: '120px' }}
                    />
                  </td>

                  {/* Tax Code */}
                  <td className="m-0 p-0">
                    <select
                      className="p-1"
                      value={row.TaxCodeValue || row?.VATDescription || ''}
                      onChange={(e) => handleVatChange(index, e.target.value)}
                      style={{ width: '300px' }}
                    >
                      <option value="">Select Tax Code</option>
                      {taxCodeList.map((tax) => (
                        <option key={tax.value} value={tax.value}>
                          {tax.text}
                        </option>
                      ))}
                    </select>
                  </td>

                  {/* Vat */}
                  <td className="m-0 p-0">
                    <input className="p-1" value={row?.VAT?.toFixed(currencyPrecision?.decimalNumbers) || 0} disabled style={{ width: '100px' }} />
                  </td>

                  {/* Total */}
                  <td className="m-0 p-0">
                    <input className="p-1" value={row.Total?.toFixed(currencyPrecision?.decimalNumbers) || '0.00'} disabled style={{ width: '120px' }} />
                  </td>

                  {/* Posting */}
                  <td className="m-0 p-0 text-center">
                    <input
                      type="checkbox"
                      checked={row.Posting || false}
                      onChange={(e) => handleCheckboxChange(index, 'Posting', e.target.checked)}
                      style={{ width: '20px', height: '20px' }}
                    />
                  </td>

                  {/* Remarks */}
                  <td className="m-0 p-0">
                    <input
                      className="p-1"
                      value={row.Remarks || ''}
                      onChange={(e) => handleCheckboxChange(index, 'Remarks', e.target.value)}
                      style={{ width: '400px' }}
                    />
                  </td>

                  {/* From Rent */}
                  <td className="m-0 p-0 text-center">
                    <input
                      type="checkbox"
                      className="w-100"
                      checked={row.IsDeposit || false}
                      onChange={(e) => handleCheckboxChange(index, 'IsDeposit', e.target.checked)}
                      style={{ width: '20px', height: '20px' }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
      {gridVisibility[3] && <PaymentInvoices InvoiceList={InvoiceList} />}
      </Modal.Body>
      <Modal.Footer>
        {loading === true ? (
          <button className="mainbtn" type="button"><ClipLoader color="#ffffff" className="mt-1" size={25} /></button>
        ) : (
          <button className="mainbtn" onClick={handleSave} type="button"><FaSave className="center mt-1 mx-2" /><div>Save</div></button>
        )}
        <button className="mainbtnRed" onClick={handleResetAll} type="button"><RiRefreshLine className="center mt-1 mx-2" /><div>Reset</div></button>
        <button className="mainbtnSecondary" onClick={handleClose} type="button"><FaChevronLeft className="center mt-1 mx-2" /><div>Cancel</div></button>
      </Modal.Footer>
    </Modal>
  );
};
export default AddLeaseAgrement;
